import gql from 'graphql-tag';

export const CREATE_PIXEL_APP_MUTATION = gql`
  mutation CreatePixelTrackingAppMutation(
    $domain: String!
    $timezone: String!
    $pageUniquePart: String!
    $facebookPixelId: String!
    $estimatedMonthlyTraffic: String!
    $trafficEnabled: Boolean!
  ) {
    createPixelTrackingApp(
      domain: $domain
      timezone: $timezone
      pageUniquePart: $pageUniquePart
      facebookPixelId: $facebookPixelId
      estimatedMonthlyTraffic: $estimatedMonthlyTraffic
      trafficEnabled: $trafficEnabled
    ) {
      pixelTrackingAppId
      errors
    }
  }
`;
